"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var PowerUnplugedIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    d: "M8.562 7.378l2.532-3.257-.707-.707L11.801 2l2.122 2.121 2.828-2.828a1 1 0 011.414 1.414l-2.828 2.829 2.828 2.828 2.829-2.828a1 1 0 011.414 1.414L19.58 9.778 21.7 11.9l-1.413 1.415-.707-.707-3.257 2.532 3.94 3.94a1 1 0 11-1.414 1.415L3.293 4.937a1 1 0 011.414-1.414l3.855 3.855zM7.458 17.883l-4.044 4.044L2 20.512l4.043-4.043-.668-.668a1 1 0 010-1.415L7.762 12l4.242 4.243-2.386 2.386a1 1 0 01-1.414 0l-.746-.746z"
  }));
});
PowerUnplugedIcon.category = 'Device';
var _default = PowerUnplugedIcon;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@mineral/icons/build/PowerUnplugedIcon.js
// module id = 1132
// module chunks = 0